import React from 'react';
import LazyImage from '../../../components/CustomLibraries/LazyImage';
import { RiDeleteBin6Line } from '../../../components/icons';

const FilePreview = ({ file, cancelClick }) => {
  return (
    <div className="col-4 cmnFileUploadBox ps-3 mt-3">
      <div className="cmnFileUploadBoxIn rounded position-relative overflow-hidden">
        <LazyImage
          src={
            file.fie_type.includes('image')
              ? file.url
              : 'https://cdn-icons-png.flaticon.com/512/337/337946.png'
          }
          className="object-fit-cover w-100 h-100 float-start"
          alt="attachment"
        />
        <a
          href="javascript:void(0)"
          className="cmnFileUploadRemove rounded position-absolute d-flex justify-content-center align-items-center bg-white bg-opacity-75"
          onClick={cancelClick}
        >
          <RiDeleteBin6Line customClass="fs-2 text-danger" />
        </a>
      </div>
    </div>
  );
};

export default FilePreview;
